import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default class SectionsInclusionsEdit {

  constructor() {}

  render() {

    // Length of text area
    $('textarea').keyup(function() {
      $('.reset-to-default').removeClass('d-none');
      let len = $(this).val().length;
      $(this).closest('.form-group').find('.text-length').empty().append(len + ' characters');
    })

    $('.reset-to-default').click(function() {
      let fg = $(this).closest('.form-group')
      let field = fg.find('textarea');
      let def = field.attr('data-default');
      fg.find('.field_with_errors').replaceWith(field);
      field.val(def);
      $('.reset-to-default').addClass('d-none');
    })    

    // On selecting a cover
    $('#reportCoverSelect .image-container').on('click', function() {
      let url = $(this).attr("data-image-url");
      $('#reportCoverSelect .image-container.active').removeClass('active');
      $(this).addClass('active');
      $('#report_pdf_cover_image_url').val(url);
    })

    // Display footnote section
    $('#includeFootnote').change(function() {
      if ($(this).is(':checked')) {
        $('#footnoteContainer').removeClass('d-none');
      } else {
        $('#footnoteContainer').addClass('d-none');
      }
    });

    // Check for category set active
    const checkActiveSet = function(el) {
      let record_ids = JSON.parse(el.attr('data-record-ids'));
      let active = 0;
      $.each(record_ids, function(index, sid) {
        let icon = $('.impact-assessment-icon[data-record-id=\'' + sid + '\']');
        if ( (icon.hasClass('active')) && (active === index)) {
          el.addClass('active');
          active += 1;
        } else {
          el.removeClass('active');
        }
      });
    }
    $('.category-set').each(function() { checkActiveSet($(this)); });

    // Update title on selecting a metric
    $('.default-typeahead[data-selector=\'#hidden_metric_id\']').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let name = suggestion.name;
      let metric_uom = suggestion.metric_uom;
      $('#section_inclusion_name').val(name);
      if (typeof metric_uom !== 'undefined') {
        if (metric_uom == 'boolean') {
          $('#section_inclusion_text').val('True or False');
        } else {
          $('#section_inclusion_text').val(metric_uom);
        }
      }
    })

    // Update title on selecting a screen
    $('.default-typeahead[data-selector=\'#hidden_screen_id\']').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let name = suggestion.name;
      $('#section_inclusion_name').val(name);
      $('#section_inclusion_text').val('Percent revenue flagged for involvement');
    })

    // Template to append selected metric
    let selectedMetTemp = function(id, name) {
      let text = "<div class='selected-opt w-100 p-2 d-flex align-items-center'>";
      text += "<div class='mr-2'>" + name + "</div>";
      text += "<div class='ml-auto'>";
      text += "<a class='clickable remove-selected-metric' data-id='" + id + "'>";
      text += "<svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>";
      text += "<g id='Icon Right'>";
      text += "<path id='Vector' d='M4.2 3.79989V2.39989C4.2 1.88442 4.61787 1.46655 5.13333 1.46655H8.86667C9.38213 1.46655 9.8 1.88442 9.8 2.39989V3.79989M0.875 4.26655H13.125M2.275 4.26655V13.5999C2.275 14.1154 2.69287 14.5332 3.20833 14.5332H10.7917C11.3071 14.5332 11.725 14.1154 11.725 13.5999V4.26655M7 7.12489V11.8499M5.075 7.12489V11.8499M8.925 7.12489V11.8499' stroke='#DA3547' stroke-linecap='round' stroke-linejoin='round'></path>";
      text += "</g></svg></a></div></div>";
      return text;
    }

    // Function to remove on click
    let removeSelectedMetric = function() {
      $('.remove-selected-metric').click(function() {
        let id = $(this).data('id').toString();
        let count = $('.remove-selected-metric').length;
        if (count === 1) {
          ToastCustom({title: 'Cannot remove last metric', message: 'You must select at least one metric for this section', delay: 10000, type: 'warning'})
        } else {
          let selectedIds = $('#hidden_key_metrics').val();
          selectedIds = selectedIds.replace(id, '');
          selectedIds = selectedIds.replace(',,', ',');
          selectedIds = selectedIds.replace(', ,', ',');
          selectedIds = selectedIds.replace(', ]', ']');
          selectedIds = selectedIds.replace(',]', ']');
          selectedIds = selectedIds.replace('[,', '[');
          selectedIds = selectedIds.replace('[, ', '[');
          $('#hidden_key_metrics').val(selectedIds);
          $(this).closest('.selected-opt').remove();
        }
      })
    }
    removeSelectedMetric();

    // Update key metrics on selecting
    $('.metrics-multi-select').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let id = suggestion.record_id;
      let name = suggestion.name;
      let selectedIds = $('#hidden_key_metrics').val();
      let arr = [];
      try {
        // Clean up selectedIds string: remove trailing/leading commas, double commas, spaces
        let cleaned = selectedIds
          .replace(/,+/g, ',')
          .replace(/\[,+/g, '[')
          .replace(/,+\]/g, ']')
          .replace(/\s+/g, '');
        arr = JSON.parse(cleaned);
        if (!Array.isArray(arr)) arr = [];
      } catch (e) {
        arr = [selectedIds];
      }
      if (arr.indexOf(id) === -1) {
        arr.push(id);
        selectedIds = JSON.stringify(arr);
        $('.multi-selected-container').append(selectedMetTemp(id, name));
        removeSelectedMetric();
      }
      $('#hidden_key_metrics').val(selectedIds);
      $(this).typeahead('val', '').blur();
    })

    // Submit form and reload page on selecting an SDG to update available SDG options
    let reloadPageOnSdgSelect = function() {
      let form = $('#edit_section_inclusion_form');
      let location = window.location.href;
      let reloadInput = form.find("input[name='reload_page']");
      if (reloadInput.length === 0) {
        reloadInput = $("<input>", { type: "hidden", name: "reload_page" });
        form.prepend(reloadInput);
      }
      reloadInput.val('true');
      $('.modal-footer').find('input[type=submit]').click();
    }

    // Function to remove SDG on click
    $('.remove-selected-sdg').click(function() {
      let id = $(this).data('id').toString();
      let selectedIds = $('#hidden_key_sdgs').val();
      let arr = selectedIds.split(',').filter(x => x !== id && x !== '');
      $('#hidden_key_sdgs').val(arr.join(','));
      $(this).closest('.selected-opt').remove();
      reloadPageOnSdgSelect();
    })

    // Update SDGs on selecting
    $('.sdgs-multi-select').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let id = suggestion.record_id;
      let selectedIds = $('#hidden_key_sdgs').val();
      let arr = selectedIds ? selectedIds.split(',').filter(x => x !== '') : [];
      
      if (arr.indexOf(id.toString()) === -1) {
        arr.push(id.toString());
        $('#hidden_key_sdgs').val(arr.join(','));
      }
      reloadPageOnSdgSelect();
    })

    // Action when clicking on a card
    // Check the box when click a row or a checkbox in a row
    $('.impact-assessment-icon').on('click', function() {

      let checkbox = $(this).find('input[type=\'checkbox\']');
      let hiddenDestroy = $(this).find('input.hidden-destroy');
      let limit = parseInt($(this).attr('data-limit'));
      let checkedBoxes = $('.impact-assessment-icon input.checkbox:checked').not(checkbox);
      let willCheck = !checkbox[0].checked;
      let newCheckedCount = checkedBoxes.length + (willCheck ? 1 : 0);

      // Only block if user is trying to check and would exceed limit
      if (willCheck && newCheckedCount > limit) {
        ToastCustom({title: 'Max ' + limit, message: 'You may select a maximum of up to ' + limit, delay: 10000});
        checkbox.prop('checked', false);
        checkbox.val("");
        hiddenDestroy.val('true');
        $(this).removeClass('active');
      } else if (willCheck) {
        checkbox.prop('checked', true);
        checkbox.val(checkbox.data("record-id"));
        hiddenDestroy.val('false');
        $(this).addClass('active');
      } else {
        checkbox.prop('checked', false);
        checkbox.val("");
        hiddenDestroy.val('true');
        $(this).removeClass('active');
      }

      // Check/uncheck categories
      let category_ids = $(this).attr('data-category-ids');
      if (typeof category_ids !== 'undefined') {
        $.each(JSON.parse(category_ids), function(index, sid) {
          let setEl = $('.category-set[data-category-id=\'' + sid + '\']');
          checkActiveSet(setEl);
        })
      }

      // Blur focus; required in touch to update active class
      $(this).blur();

    });

    // Select/deselect all related records on select of category
    $('.category-set').click(function() {
      let record_ids = JSON.parse($(this).attr('data-record-ids'));
      let limit = $(this).attr('data-limit');

      if ($(this).hasClass('active')) {
        $.each(record_ids, function(index, sid) {
          let icon = $('.impact-assessment-icon[data-record-id=\'' + sid + '\']');
          let checkbox = icon.find('input[type=\'checkbox\']');
          let hiddenDestroy = icon.find('input.hidden-destroy');
          checkbox.prop('checked', false);
          checkbox.val("");
          hiddenDestroy.val('true');
          icon.removeClass('active');
        });
        $(this).removeClass('active');

        if ($(this).hasClass('all-records')) {
          $('.category-set').removeClass('active');
        }

      } else {
        $.each(record_ids, function(index, sid) {
          if ((typeof limit !== 'undefined') && (index >= parseInt(limit))) {return false}
          let icon = $('.impact-assessment-icon[data-record-id=\'' + sid + '\']');
          let checkbox = icon.find('input[type=\'checkbox\']');
          let hiddenDestroy = icon.find('input.hidden-destroy');
          checkbox.prop('checked', true);
          checkbox.val(checkbox.data("record-id"));
          hiddenDestroy.val('false');
          icon.addClass('active');
        });
        $(this).addClass('active');

        if ($(this).hasClass('all-records')) {
          $('.category-set').addClass('active');
        }

      }

      // Blur focus; required in touch to update active class
      $(this).blur();

    });

    // Toggle display option icons (Bar/Table)
    $('[data-behavior="display-option-toggle"] .display-option-icon').on('click', function() {
      let selectedValue = $(this).data('value');
      let container = $(this).closest('[data-behavior="display-option-toggle"]');
      container.find('.display-option-icon').removeClass('active');
      $(this).addClass('active');
      container.find('.display-option-input').val(selectedValue);
    });

  }

}
